<script setup lang="ts">
import DispatchJobAdditionalInfoDescList from '@/components/descLists/DispatchJobAdditionalInfoDescList.vue';
import DispatchJobBaseInfoDescList from '@/components/descLists/DispatchJobBaseInfoDescList.vue';
import SimpleLoader from '@/components/loaders/SimpleLoader.vue';
import JobMap from '@/components/maps/JobMap.vue';
import DispatchSectionEmptyText from '@/components/texts/DispatchSectionEmptyText.vue';
import { useDispatchDashboardViewStore } from '@/stores/useDispatchDashboardViewStore';

const dispatchDashboardViewStore = useDispatchDashboardViewStore();
</script>

<template>
  <section
    :class="$style.dispatchJobDetailsSection"
    data-testid="dispatchJobDetailsSection"
  >
    <DispatchSectionEmptyText v-if="!dispatchDashboardViewStore.activatedJob" />
    <template v-else>
      <DispatchJobBaseInfoDescList
        class="my-4"
        :job="dispatchDashboardViewStore.activatedJob"
        :detailed-customer="dispatchDashboardViewStore.activatedJob.customer"
        is-staff
      />
      <h4>Additional information</h4>
      <DispatchJobAdditionalInfoDescList
        :job="dispatchDashboardViewStore.activatedJob"
        :loading="dispatchDashboardViewStore.data.isFetchingDispatchJobs"
        class="mb-4"
      />
      <SimpleLoader
        v-if="dispatchDashboardViewStore.data.isAwaitingStopLocations"
        :size="60"
        :width="4"
        class="mx-auto my-34"
      />
      <JobMap
        v-else
        :stop-locations="dispatchDashboardViewStore.data.stopLocations"
        class="mb-4"
      />
    </template>
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.dispatchJobDetailsSection {
}
</style>
